/** User-facing strings: device. */
export const device = {
    metadataTitle: "Approve an agent",
    signIn: {
        title: "Sign in to approve this agent",
        detail: "Sign in with the account whose token started the agent. You come back to this page afterwards.",
        signIn: "Sign in",
        signUp: "Sign up",
    },
    request: {
        title: "Approve this agent?",
        intro: "Check that the code below is the one your terminal printed.",
        code: "Code",
        agentName: "Agent name",
        agentNameMissing: "Not reported by this agent",
        fingerprint: "Fingerprint",
        fingerprintMissing: "Not recorded",
        requested: "Requested",
        timeNotRecorded: "Time not recorded",
        requestedFrom: "{age} · from {ip}",
        organisation: "Organisation",
        personalOrganisation: "Your personal organisation",
        warning:
            "Only approve if you started this on your own machine. The agent will be able to publish OPC UA servers in this organisation; to enrol it in another one, switch organisation on the dashboard first, then reload this page.",
        staleWarning:
            "The agent waits about two minutes for this approval. If it has stopped waiting, deny this request and run the config command again.",
        approve: "Approve",
        deny: "Deny",
    },
    approved: {
        title: "Approved: go back to your terminal",
        namedBefore: "The agent",
        namedAfter: "finishes its setup on its own within a few seconds.",
        unnamed: "The agent finishes its setup on its own within a few seconds.",
        closeTab: "You can close this tab.",
        listHint: "Once the agent is serving, it appears in your list of agents.",
        openAgents: "Open Agents & servers",
    },
    denied: {
        title: "Request denied",
        detail: "Nothing was enrolled. The agent in the terminal stops and reports that the request was denied.",
    },
    failure: {
        newCodeHint: "Go back to your terminal and run the opcua-relay-agent config command again to get a new link.",
        expired: {
            title: "This code has expired or was already used",
            detail: "Codes are valid for 10 minutes, work once, and only for the account whose token started them. {hint}",
        },
        used: {
            title: "This code was already used",
            detail: "This request was already approved or denied, and a code can only enrol one agent. {hint}",
        },
        denied: {
            title: "This request was denied",
            detail: "Nothing was enrolled and the agent was told. If this was a mistake: {hint}",
        },
        invalid: {
            title: "This code is not valid",
            detail: "Check that you opened the complete link printed by the agent. {hint}",
        },
        forbidden: {
            title: "We could not verify this approval",
            detail: "Nothing was changed. Reload this page from the link printed by the agent, sign in if asked, and try again.",
        },
        unknown: {
            title: "We could not enrol your device",
            detail: "Something went wrong on our side. Try again in a moment, and if it keeps failing, contact support.",
        },
    },
};
